<template>
<div class="chapter">
<div class="inner_page">
<p class="ded_fo">To Paul Schnabel, my father in the truest sense of the word, who has been preaching the gospel for seventy years</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Mark_dedication.vue?5f3ed11d